import React from 'react';
import { Shield } from 'lucide-react';
import { CoverageHero } from '../components/CoverageHero';
import { CoverageCTA } from '../components/CoverageCTA';

const Medicare = () => {
  return (
    <div className="min-h-screen">
      <CoverageHero
        title="Medicare Guidance Made Simple"
        subtitle="Navigate your Medicare options with confidence. We help you compare Medicare Advantage, Medicare Supplement, and prescription drug coverage. Guidance with purpose."
      />
      <section className="py-8">
        <div className="container mx-auto px-4"><div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-brand-blue mb-6">Medicare Solutions Tailored to Your Needs</h2>
            <p className="text-base md:text-lg text-gray-700 leading-relaxed">Whether you're turning 65, already on Medicare, or exploring your options, Purposefully Covered Insurance Group is here to help.</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            {[{title:"Turning 65?",desc:"Your Initial Enrollment Period is a 7-month window around your 65th birthday."},{title:"Already on Medicare?",desc:"We can review your current plan during Annual Enrollment (Oct 15 - Dec 7)."},{title:"Medicare Advantage",desc:"All-in-one plans that may include prescription drugs, dental, vision, hearing, and wellness benefits."},{title:"Medicare Supplement (Medigap)",desc:"Works alongside Original Medicare to cover copays, coinsurance, and deductibles."}].map(item=>(<div key={item.title} className="flex items-start gap-3 bg-white p-6 rounded-lg shadow-md"><Shield className="text-brand-orange flex-shrink-0 mt-1" size={24}/><div><h3 className="font-bold text-lg text-brand-blue mb-2">{item.title}</h3><p className="text-gray-700">{item.desc}</p></div></div>))}
          </div>
          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 mb-12">
            <h3 className="font-bold text-lg text-yellow-800 mb-2">Important Medicare Compliance Notice</h3>
            <p className="text-gray-700 text-sm">Purposefully Covered Insurance Group is owned and operated by David Ashley, a licensed and insured insurance agent. We are not affiliated with or endorsed by the U.S. government or Medicare.</p>
          </div>
        </div></div>
      </section>
      <section className="py-8 bg-gray-50">
        <div className="container mx-auto px-4"><div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-blue mb-8 text-center">Medicare Enrollment Periods</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[{title:"Initial Enrollment",period:"7-month period around your 65th birthday"},{title:"Annual Enrollment",period:"October 15 - December 7 each year"},{title:"Special Enrollment",period:"Qualifying life events"}].map(item=>(<div key={item.title} className="bg-white p-6 rounded-lg shadow-md"><h3 className="font-bold text-xl text-brand-blue mb-3">{item.title}</h3><p className="text-gray-700">{item.period}</p></div>))}
          </div>
        </div></div>
      </section>
      <CoverageCTA heading="Request My Medicare Review" />
    </div>
  );
};

export default Medicare;
